import { useMutation } from '@tanstack/react-query'
import { panService } from '../services/panService'
import { MakeProposalRequest } from '../services/panService/makeProposal'
import { GenerateOffersRequest } from '../services/panService/generateOffers'
import { toast } from '@/view/components/ui/use-toast'
import { SendProposalRequest } from '../services/panService/sendProposal'

export const usePanMutations = () => {
  const makeProposalMutation = useMutation({
    mutationFn: (payload: MakeProposalRequest) =>
      panService.makeProposal(payload),

    onError: (error: any) => {
      toast({
        title: 'Erro ao criar proposta',
        description: error?.message || 'Tente novamente mais tarde.',
        variant: 'destructive',
      })
    },
  })

  const generateOffersMutation = useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string
      payload: GenerateOffersRequest
    }) => panService.generateOffers(id, payload),

    onError: (error: any) => {
      toast({
        title: 'Erro ao gerar ofertas',
        description: error?.message || 'Tente novamente mais tarde.',
        variant: 'destructive',
      })
    },
  })

  const sendProposalMutation = useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string
      payload: SendProposalRequest
    }) => panService.sendProposal(id, payload),

    onError: (error: any) => {
      toast({
        title: 'Erro ao enviar proposta',
        description: error?.message || 'Tente novamente mais tarde.',
        variant: 'destructive',
      })
    },
  })

  return {
    makeProposalMutation,
    generateOffersMutation,
    sendProposalMutation,
  }
}
